import React from 'react'
import { connect } from 'react-redux'
//Actions
import {
  addMetrcEmployeeKey,
  deleteMetrcEmployeeKey,
  getBiotrackAccount,
  getMetrc,
  getMetrcEmployeeKeys,
  getMetrcFacilitiesData,
  getMetrcFacilitiesDataSearch,
  updateBiotrackAccount,
  updateMetrcAccount,
  updateMetrcEmployeeKey,
} from '../../../actions/thirdParty'

import { fetchEmployees, searchEmployees } from '../../../actions/employee'
//Components
import Compliance from '../../../components/Compliance/Compliance'
//Wrappers
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
//Actions
import { getShopList } from '../../../actions/shop'
import { openErrorMessage } from '../../../actions/message'
//
import { isValidString } from '../../../utils/string'
import moment from 'moment'
import { updateMerchantEmployeeKey } from '../../../api/complianceService'
import { serializeMetrcEmployeeConfigRequest } from '../../../utils/complianceServiceDataBuilders'
import qs from 'query-string'
import { hasAccess } from '../../../utils/api'

const ComplianceEditable = EditableHOCWrapper(Compliance)
const TABS = {
  BIOTRACK_LOCATIONS: 'BIOTRACK_LOCATIONS',
  METRC_FACILITIES: 'METRC_FACILITIES',
  METRC_EMPLOYEE_KEYS: 'METRC_EMPLOYEE_KEYS',
}

const TABS_QUERY_PARAM = {
  BIOTRACK_LOCATIONS: 'biotrack-locations',
  METRC_FACILITIES: 'metrc-facilities',
  METRC_EMPLOYEE_KEYS: 'metrc-employees',
}

class ComplianceContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: null,
    }
  }

  onSave = () => (data, afterOnSave) => {
    let { biotrackAccount = {} } = this.props.thirdPartyReducer
    biotrackAccount.locations = data.locations
    let updatedBiotrackAccount = [{ ...biotrackAccount }]
    const isValid = this.validateBiotrackAccount(data)
    if (isValid) {
      this.props.dispatch(updateBiotrackAccount(updatedBiotrackAccount)).then((_) => {
        this.props.dispatch(getBiotrackAccount())
        afterOnSave()
      })
    }
  }

  onFacilititesSave = () => (data, afterOnSave) => {
    const { metrcAccounts } = this.props.thirdPartyReducer
    metrcAccounts[0].facilities = data.facilities
    let updatedMetrcAccount = metrcAccounts[0]
    const isValid = this.validateMetrcAccount(updatedMetrcAccount)
    if (isValid) {
      this.props.dispatch(updateMetrcAccount([{ ...updatedMetrcAccount }])).then((_) => {
        this.props.dispatch(getMetrc())
        afterOnSave()
      })
    }
  }

  validateBiotrackAccount = (data) => {
    const { shopsList } = this.props.shopReducer
    const { locations } = data
    let errorMsg = ''
    for (let i = 0; i < locations.length; i++) {
      const currentShop =
        (shopsList.values && shopsList.values.find((shop) => shop.id === locations[i].shopId)) || {}
      if (!locations[i].stateCode) {
        errorMsg = `Please select state code for ${currentShop.name || ''}`
        break
      }
    }
    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    }
    return true
  }

  validateMetrcAccount = (data) => {
    const { shopsList = {} } = this.props.shopReducer
    const { facilities } = data
    let errorMsg = ''

    for (let i = 0; i < facilities.length; ++i) {
      if (!facilities[i].stateCode) {
        const currentShop =
          (shopsList.values && shopsList.values.find((shop) => shop.id === facilities[i].shopId)) ||
          {}
        errorMsg = `Please select state code for ${currentShop.name || ''}`
        break
      }
    }

    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    }

    return true
  }

  searchFacilities = (env, stateCode, apiKey) => {
    this.props.dispatch(getMetrcFacilitiesDataSearch(env, stateCode, apiKey))
  }

  onChangeActiveTab = (tab) => {
    this.setState({ activeTab: tab })
  }

  retrieveFacilities = async () => {
    await this.props.dispatch(getMetrcFacilitiesData())
  }

  onEmployeeSearch = (searchTerm) => {
    return this.props.dispatch(searchEmployees(searchTerm))
  }

  onSearchEmployeeKey = () => {
    const { searchTerm, start, limit } = this.state
    this.props.dispatch(getMetrcEmployeeKeys({ start, limit, searchTerm })).then((res) => {
      let metrcEmployeeKeys = []
      if (res && res.values && res.values.length) {
        metrcEmployeeKeys = res.values.map((element) => {
          return {
            ...element,
            editMode: false,
            lastModified: moment().valueOf(),
          }
        })
      }
      this.setState({ metrcEmployeeKeys })
    })
  }

  validateEmployeeKey = (request) => {
    if (!isValidString(request.employeeId)) {
      this.props.dispatch(openErrorMessage('Please select Employee.'))
      return false
    }

    if (!isValidString(request.userApiKey)) {
      this.props.dispatch(openErrorMessage('Please enter Metrc API Key.'))
      return false
    }

    return true
  }

  saveEmployeeKey = (request) => {
    return this.props.dispatch(addMetrcEmployeeKey(request))
  }

  onUpdateEmployeeKey = (data, afterOnSave) => {
    if (this.validateEmployeeKey(data)) {
      this.props.dispatch(updateMetrcEmployeeKey(data)).then((res) => {
        afterOnSave(res)
      })
      this.updateEmployeeMetrcKeyForMerchants(data)
    }
  }

  updateEmployeeMetrcKeyForMerchants = (data) => {
    const { userApiKey, companyId, employeeId, enabled } = data
    const request = serializeMetrcEmployeeConfigRequest(userApiKey, enabled)
    updateMerchantEmployeeKey(companyId, employeeId, request)
  }

  setEmployeeKeyForDelete = (selectedEmployeeKey) => {
    this.setState({ selectedEmployeeKey })
  }

  deleteEmployeeKey = (id) => {
    return this.props.dispatch(deleteMetrcEmployeeKey(id))
  }

  onChangeTerm = (event) => {
    this.setState({
      searchTerm: event && event.target && event.target.value ? event.target.value : '',
    })
  }

  getQueryParams = () => {
    const searchParams = window.location.search
    return qs.parse(searchParams)
  }

  componentDidMount = () => {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session
    const { complianceType = '' } = assignedShop
    const queryParams = this.getQueryParams()
    const queryTab = queryParams && queryParams.tab ? queryParams.tab : ''
    switch (complianceType) {
      case 'METRC':
        if (queryTab === TABS_QUERY_PARAM.METRC_EMPLOYEE_KEYS) {
          this.setState({ activeTab: TABS.METRC_EMPLOYEE_KEYS })
        } else {
          this.setState({ activeTab: TABS.METRC_FACILITIES })
        }
        break
      case 'BIOTRACK':
      default:
        this.setState({ activeTab: TABS.BIOTRACK_LOCATIONS })
        break
    }
    this.props.dispatch(getBiotrackAccount())
    this.props.dispatch(getMetrc())
    this.props.dispatch(getShopList())
    this.props.dispatch(fetchEmployees()).then(({ values }) => {
      if (values && values.length) {
        this.setState({ employees: values })
      }
    })

    if (hasAccess()) {
      this.onSearchEmployeeKey()
    }
  }

  render() {
    const {
      biotrackAccount = {},
      biotrackEmployeeKeys,
      metrcAccounts = [],
      metrcFacilities = {},
      metrcLocationTypes = [],
    } = this.props.thirdPartyReducer
    const {
      employees = [],
      activeTab,
      metrcEmployeeKeys = [],
      selectedEmployeeKey,
      searchTerm = '',
    } = this.state

    const complianceData = {
      locations: biotrackAccount && biotrackAccount.locations,
      facilities: metrcAccounts[0] && metrcAccounts[0].facilities,
    }
    const { shopsList = {} } = this.props.shopReducer
    const { session = {} } = this.props.authReducer
    const shopListValues = shopsList.values || []
    return (
      <React.Fragment>
        <ComplianceEditable
          key={metrcAccounts.length + (biotrackAccount.locations || []).length}
          metrcAccount={metrcAccounts[0]}
          shops={shopListValues}
          dataToEdit={complianceData}
          onChangeActiveTab={this.onChangeActiveTab}
          TABS={TABS}
          activeTab={activeTab}
          onSave={this.onSave()}
          onFacilititesSave={this.onFacilititesSave()}
          retrieveFacilities={this.retrieveFacilities}
          biotrackEmployeeKeys={biotrackEmployeeKeys}
          searchFacilities={this.searchFacilities}
          facilitiesOptions={metrcFacilities}
          shop={session.assignedShop}
          metrcLocationTypes={metrcLocationTypes}
          dispatch={this.props.dispatch}
          employees={employees}
          metrcEmployeeKeys={metrcEmployeeKeys}
          onEmployeeSearch={this.onEmployeeSearch}
          saveEmployeeKey={this.saveEmployeeKey}
          onUpdateEmployeeKey={this.onUpdateEmployeeKey}
          validateEmployeeKey={this.validateEmployeeKey}
          searchTerm={searchTerm}
          onSearchEmployeeKey={this.onSearchEmployeeKey}
          onChangeTerm={this.onChangeTerm}
          selectedEmployeeKey={selectedEmployeeKey}
          setEmployeeKeyForDelete={this.setEmployeeKeyForDelete}
          deleteEmployeeKey={this.deleteEmployeeKey}
        />
      </React.Fragment>
    )
  }
}

const ComplianceWithTitle = ContainerWithTitleWrapper(ComplianceContainer, 'Compliance Accounts')
const ComplianceConnected = connect(
  ({ thirdPartyReducer, shopReducer, authReducer, dispatch }) => ({
    thirdPartyReducer,
    shopReducer,
    authReducer,
    dispatch,
  }),
)(ComplianceWithTitle)

export default ComplianceConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/ComplianceContainer.js